import QualifyingField from './QualifyingField';
export { QualifyingField as default };
